const Form028TC = {
    stepName: {
        ImportantNotes: "重要提示",
        ApplicationInfo: "教員註冊資料",
        Confirmation: "確認",
    },
    label: {
        teacherInfo: "教員註冊資料",
        schoolInfo: "學校資料",
        chineseName: "中文姓名",
        englishName: "英文姓名",
        title: "先生／女士",
        hkid: "身份證號碼",
        permitNo: "教員註冊證號碼",
        schoolChop: "校印",
        // schoolName: "擬受僱學校名稱",
        schoolName: "學校名稱",
        schoolNumber: "學校編號",
        signature: "申請人簽署",
        principal: "校監／校長簽名",
        applicantName: "申請人姓名",
        supervisorName: "校監／校長姓名",
        contactNo: "申請人電話",
        approverEmailAddress: "申請人電郵地址",
        date: "日期",
        //dates: "日期",
        //edbDate: "日期",
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        teacherNoOption: {
            R: "檢定教員編號",
            P: "准用教員編號",
            N: "不適用",
        },
        errTeacherNoR: "檢定教員編號",
        errTeacherNoP: "准用教員編號",
        note: "填寫申請表格須知",
        info1: "本人",
        info2: "（英文",
        info3: "）",
        info4: "，身份證號碼：",
        info5: " 教員註冊證號碼：",
        info6: "（如適用）申請並授權教育局向下述學校的校監／校長發放有關本人的教員註冊資料，包括貴局曾否拒絕本人檢定／准用教員的註冊申請、取消本人的檢定／准用教員註冊或曾否就本人的教師註冊資格向本人發出譴責／警告／勸喻信等。",

        //FormB
        SchoolEmail: "學校電郵",
        fromSchoolSupervisorName: "校監／校長姓名",
        fromSchoolSchoolName: "學校名稱",
        fromSchoolSchoolNumber: "學校編碼",
        fromSchoolAddress: "學校地址",
        fromSchoolFaxNumber: "傳真號碼",
        statement: "我已閱讀、理解並同意上述條款和條件。",
        termsConditions:
            "本人理解校監/校長及教師需要擁有「智方便+」帳戶才能提交申請。",
    },

    edbNotes: {
        title: "由教育局職員填寫",
        label1: "校監／校長：",
        label2: "根據本局的紀錄，就以上申請人的查詢，現回覆如下:",
        symbolStep: [
            { step: "(1)(i)" },
            { step: "(1)(ii)" },
            { step: "(1)(iii)" },
            { step: "(2)(i)" },
            { step: "(2)(ii)" },
            { step: "(2)(iii)" },
            { step: "(3)(i)" },
            { step: "(3)(ii)" },
            { step: "(4)" },
        ],
        option: {
            option1: "本局並無以上申請人的教師註冊紀錄。",
            option2: "以上申請人現為檢定教員。",
            option3:
                "以上申請人現為／曾為准用教員 。<br />（如有關准用教員停止受僱於其准用教員許可證上所指明的學校，該准用教員許可證將被視作無效。）",
            option4:
                "本局<u>沒有</u>拒絕以上申請人的檢定／准用教員註冊申請或取消以上申請人的檢定／准用教員註冊的紀錄。",
            option5:
                "本局曾於_______年____月____日<u>拒絕</u>以上申請人的檢定／准用教員註冊申請。",
            option6:
                "本局曾於_______年____月____日<u>取消</u>以上申請人的檢定／准用教員註冊。",
            option7:
                "本局未有就以上申請人的教師註冊資格向其發出譴責／警告／勸喻信。",
            option8:
                "本局曾於_______年____月____日就教師註冊資格向以上申請人發出*譴責／警告／勸喻信<sup >須知(3)</sup>。",
            option9: "ˆ本局現正審視以上申請人的教師註冊資格。",
        },
        label3: "學校處理應徵者的個人資料時，應遵守《個人資料(私隱)條例》的規定，以上資料亦只作處理職位申請及評估應徵者是否適合該職位之用。如有進一步查詢，請電3467 8282與教育局教師註冊小組聯絡。",
        label4: "ˆ本局在完成審視教師的教師註冊資格後 ，可能向其發出譴責／警告／勸喻信或取消其檢定／准用教員註冊。",
    },
    notes: {
        colon: [
            {
                text: "（1）",
            },
            {
                text: "（2）",
            },
            {
                text: "（3）",
            },
            {
                text: "（4）",
            },
        ],
        note: [
            {
                text: "教育局只會接受向學校發放註冊資料的申請；至於向個人或其他機構發放註冊資料的申請，將不予辦理。",
            },
            {
                text: "學校在徵得擬聘用教師的同意後，應向教育局申請將其教師註冊資料向學校發放。申請表格可於教育局網頁（<a href='http://edb.gov.hk', target='_blank'>www.edb.gov.hk</a>）下載 。",
            },
            {
                text: "如擬聘用教師根據《罪犯自新條例》（第297章）的第2（1）條可不披露其定罪，教育局並不會向學校披露本局就擬聘用教師有關定罪曾發出的譴責／警告／勸喻信的相關資料。",
            },
            {
                text: "申請人可郵寄、傳真或親身遞交填妥的申請表至教育局。收件地址如下：",
            },
        ],
        note3: [
            { text: "九龍協調道 3 號" },
            { text: "工業貿易大樓 2 樓" },
            { text: "教育局教師註冊小組" },
            {
                text: "［辦公時間：星期一至五，上午八時三十分至下午一時，下午二時至下午六時",
            },
            { text: "（ 星期六、日及公眾假期休息）］" },
            {
                text: "如有進一步查詢，請與教師註冊小組聯絡: ",
            },
            {
                text: "電話: 3467 8282",
            },
            {
                text: "傳真: 2520 0065",
            },
        ],
    },
    submittedDialog: {
        text1: "你已成功送出表格。請注意，表格尚未提交至教育局。現正等待教師填妥表格。",
        multiLayerSubmitMsg: "你將會轉到填寫表格的頁面。",
    },
    approval: {
        noteCon1: "審視，並按提交表格以便輸入資料",
        noteCon2: "審視，並按提交表格以便輸入資料及簽署",
    },
    errorMsg: {
        faxDigit: "傳真號碼必須為8位數",
    },
    // reply: "退回給學校",
};
export default Form028TC;
